<template>
    <div id="all">
      <Header></Header>
      <article>
        <router-view v-on:showSpinner="showSpinner" v-on:hideSpinner="hideSpinner()" v-on:openAlertModal="openAlertModal" v-on:openConfirmModal="openConfirmModal" v-on:openConfirmYesModal="openConfirmYesModal" v-on:openTermsModal="openTermsModal"></router-view>
        <Footer></Footer>
      </article>
      <Alert @close="closeAlertModal" v-if="alertModal" :alertMessage="alertMessage" />
      <Confirm @yes="yesConfirmModal" @no="noConfirmModal" v-if="confirmModal" :confirmMessage="confirmMessage" />
      <ConfirmYes @yes="yesConfirmModal" @no="noConfirmModal" v-if="confirmModalYes" :confirmMessage="confirmMessage" />
      <Spinner v-if="spinner" :spinnerMessage="spinnerMessage" />
      <Terms @close="closeTermsModal" v-if="termsModal" :src="termsSrc" />
    </div>
  </template>
  
  <script>
  import Header from "./components/Header.vue";
  import Footer from "./components/Footer.vue";
  import Alert from "../../../../../../WebApp/Commons/components/Alert.vue";
  import Confirm from "../../../../../../WebApp/Commons/components/Confirm.vue";
  import ConfirmYes from "../../../../../../WebApp/Commons/components/ConfirmYes.vue";
  import Spinner from "../../../../../../WebApp/Commons/components/Spinner.vue";
  import Terms from "../../../../../../WebApp/Commons/components/Terms.vue";
  
  // 画面のハンバーガーメニューとフッターのTOPへ戻るで使用
  // eslint-disable-next-line no-unused-vars
  import jqueryGolbal from "../../../../../../WebApp/Public/scripts/jquery.global.js";
  
  export default {
    components: {
      Header,
      Footer,
      Alert,
      Confirm,
      ConfirmYes,
      Spinner,
      Terms
    },
    mounted: function() {
      this.title =
        (this.$router &&
          this.$router.history &&
          this.$router.history.current &&
          this.$router.history.current.meta &&
          this.$router.history.current.meta.title) ||
        "まもりこ直営ストア";
    },
    methods: {
      showSpinner: function(message) {
        this.spinnerMessage = message || "";
        this.spinner = true;
      },
      hideSpinner: function() {
        this.spinner = false;
      },
      openAlertModal: function(message, method) {
        this.alertMessage = message;
        this.alertAfterMethod = method;
        this.alertModal = true;
      },
      closeAlertModal: function() {
        this.alertModal = false;
        if(this.alertAfterMethod){
          this.alertAfterMethod();
        }
      },
      openConfirmModal: function(message, yesMethod, noMethod) {
        this.confirmMessage = message;
        this.yesConfirmAfterMethod = yesMethod;
        this.noConfirmAfterMethod = noMethod;
        this.confirmModal = true;
      },
      openConfirmYesModal: function(message, yesMethod, noMethod) {
        this.confirmMessage = message;
        this.yesConfirmAfterMethod = yesMethod;
        this.noConfirmAfterMethod = noMethod;
        this.confirmModalYes = true;
      },
      yesConfirmModal: function() {
        this.confirmModal = false;
        this.confirmModalYes = false;
        if(this.yesConfirmAfterMethod){
          this.yesConfirmAfterMethod();
        }
      },
      noConfirmModal: function() {
        this.confirmModal = false;
        this.confirmModalYes = false;
        if(this.noConfirmAfterMethod){
          this.noConfirmAfterMethod();
        }
      },
      openTermsModal: function(src) {
        document.body.classList.add("noscroll");
        this.termsModal = true;
        this.termsSrc = src;
      },
      closeTermsModal: function() {
        document.body.classList.remove("noscroll");
        this.termsModal = false;
      },
    },
    watch: {
      $route(to, from) {  // eslint-disable-line
        this.spinner = false;
        this.title = (to.meta && to.meta.title) || "まもりこ機器販売サイト";
      }
    },
    name: "app",
    data: function() {
      return {
        title: "まもりこ機器販売サイト",
        spinner: false,
        spinnerMessage: false,
        alertModal: false,
        alertMessage: "",
        alertAfterMethod: null,
        confirmModal: false,
        confirmModalYes: false,
        confirmMessage: "",
        yesConfirmAfterMethod: null,
        noConfirmAfterMethod: null,
        termsModal: false,
        termsSrc: ""
      };
    }
  };
  </script>
  <style>
  body.noscroll {
    overflow: hidden;
  }
  </style>
  <style src="../../../../../../WebApp/Public/css/styles.css"></style>
  <style src="../../../../../../WebApp/Public/css/footer_hmenu_sns.css"></style>
  